// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"23674":"de0dc38766212cd4ac50","80537":"711ba736f3b004545e06"}[chunkId] + ".css";
};